import { Pipe, PipeTransform, inject } from '@angular/core';
import { EnvironmentService } from '../../core/services/environment.service';

/**
 * Pipe to prefix asset paths with the current (or overridden) artwork environment path.
 *
 * Usage in templates:
 *   <img [src]="'logos/app-logo-horizontal.png' | envPrefix" />
 *
 * Resolves to:
 *   - Normal: /artwork/development/logos/app-logo-horizontal.png
 *   - Override active: /artwork/production/logos/app-logo-horizontal.png
 *
 * This pipe is impure to reactively update when the artwork override changes.
 * It reads from the artworkPath signal which changes when override is set/cleared.
 */
@Pipe({
  name: 'envPrefix',
  standalone: true,
  pure: false, // Impure to react to signal changes in EnvironmentService
})
export class EnvPrefixPipe implements PipeTransform {
  private environmentService = inject(EnvironmentService);

  transform(assetPath: string): string {
    // Remove leading slash if present
    const cleanPath = assetPath.startsWith('/') ? assetPath.slice(1) : assetPath;

    // Get current artwork path (with override if active) - reactive via signal
    const artworkPath = this.environmentService.artworkPath();

    return `/${artworkPath}/${cleanPath}`;
  }
}
